/* In-cart Lens Care Kit: opt-in checkbox (unticked by default). Tick adds the kit, untick removes it; kit lines are removed if no eligible glasses remain. */
(() => {
  const OPT_OUT = 'ylz_lenskit_optout';
  let busy = false;
  let timer = null;

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const isCartPage = () => document.body.classList.contains('template-cart') || /\/cart\/?$/.test(location.pathname);
  const optedOut = () => { try { return sessionStorage.getItem(OPT_OUT) === '1'; } catch (e) { return false; } };
  const setOptOut = (v) => { try { v ? sessionStorage.setItem(OPT_OUT, '1') : sessionStorage.removeItem(OPT_OUT); } catch (e) {} };

  const getRow = () => {
    const rows = [...document.querySelectorAll('[data-lenskit-row]')];
    return rows.find((r) => r.offsetParent !== null) || rows[0] || null;
  };
  const lines = (row) => (row.dataset.kitLines || '').split(',').filter(Boolean).map((s) => { const [key, kind] = s.split('|'); return { key, kind }; });

  const refresh = () => {
    if (isCartPage()) { location.reload(); return; }
    document.body.dispatchEvent(new Event('update:miniCart'));
  };
  const post = (url, body) => fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  const removeLines = async (ls) => { for (const l of ls) await post('cart/change.js', { id: l.key, quantity: 0 }); };

  async function run(fn) {
    if (busy) return; busy = true;
    try { await fn(); refresh(); } catch (e) { console.warn('[lenskit]', e); } finally { setTimeout(() => { busy = false; }, 600); }
  }

  function sync() {
    if (busy) return;
    const row = getRow();
    if (!row) return;
    const kitLines = lines(row);
    if (row.dataset.eligible !== 'true') {
      const auto = kitLines.filter((l) => l.kind === 'auto');
      if (auto.length) run(() => removeLines(auto));
      return;
    }
    // 2026-10-24: opt-in only. No auto-add; the box stays unticked until the shopper ticks it.
  }

  document.addEventListener('change', (e) => {
    const cb = e.target.closest('[data-lenskit-checkbox]');
    if (!cb) return;
    const row = cb.closest('[data-lenskit-row]');
    if (cb.checked) {
      setOptOut(false);
      run(() => post('cart/add.js', { items: [{ id: Number(row.dataset.variantId), quantity: 1, properties: { _lenskit: 'auto' } }] }));
    } else {
      setOptOut(true);
      run(() => removeLines(lines(row)));
    }
  });

  // Kit is shown only as the checkbox row: exclude it from the cart count badge and from cart recommendations
  const KIT_HANDLE = 'anti-scratch-care-kit';
  let countTimer = null;
  async function fixCount() {
    try {
      const c = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      const kitQty = c.items.filter((i) => i.handle === KIT_HANDLE).reduce((n, i) => n + i.quantity, 0);
      const shown = Math.max(0, c.item_count - kitQty);
      document.querySelectorAll('.js-cart-count, .cart-count').forEach((el) => {
        if (el.textContent.trim() !== String(shown)) el.textContent = String(shown);
        el.classList.toggle('has-items', shown > 0);
      });
    } catch (e) {}
  }
  function hideKitRecs() {
    document.querySelectorAll(`minicart-recommendations a[href*="/products/${KIT_HANDLE}"], .recommendations-item a[href*="/products/${KIT_HANDLE}"], .template-cart a[href*="/products/${KIT_HANDLE}"]`).forEach((a) => {
      if (a.closest('[data-lenskit-row]')) return;
      const card = a.closest('.swiper-slide, .product-collection, .grid__item, .product-item, li') ;
      if (card && !card.closest('.list-item > .product-item:not(.recommendations-item)')) card.style.display = 'none';
    });
  }
  const scheduleCount = () => { clearTimeout(countTimer); countTimer = setTimeout(() => { fixCount(); hideKitRecs(); }, 350); };
  document.body.addEventListener('contentUpdated', scheduleCount);
  const CART_SCOPE = '#js_cart_popup, .wrap-mini-cart, minicart-recommendations, .recommendations-item, form.cart, .main-cart';
  new MutationObserver((muts) => {
    if (muts.some((m) => m.target.nodeType === 1 && m.target.closest && m.target.closest(CART_SCOPE))) scheduleCount();
  }).observe(document.body, { childList: true, subtree: true });
  scheduleCount();
  window.addEventListener('load', () => { setTimeout(fixCount, 800); setTimeout(fixCount, 2500); });

  const schedule = () => { clearTimeout(timer); timer = setTimeout(sync, 300); };
  new MutationObserver((muts) => {
    if (muts.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches?.('[data-lenskit-row]') || n.querySelector?.('[data-lenskit-row]'))))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
})();
